var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.436957 12.675C0.436957 12.5417 0.45779 12.4167 0.499457 12.3C0.541123 12.1833 0.611956 12.075 0.711956 11.975L5.33696 7.35C5.52029 7.16667 5.74946 7.07917 6.02446 7.0875C6.29946 7.09584 6.52862 7.19167 6.71196 7.375C6.89529 7.55834 6.98696 7.79167 6.98696 8.075C6.98696 8.35834 6.89529 8.59167 6.71196 8.775L2.81196 12.675L6.73696 16.6C6.92029 16.7833 7.00779 17.0125 6.99946 17.2875C6.99112 17.5625 6.89529 17.7917 6.71196 17.975C6.52862 18.1583 6.29529 18.25 6.01196 18.25C5.72862 18.25 5.49529 18.1583 5.31196 17.975L0.711956 13.375C0.611956 13.275 0.541123 13.1667 0.499457 13.05C0.45779 12.9333 0.436957 12.8083 0.436957 12.675Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.99e7f798c139ed0a9cdbced0d66b060c.svg";
export { ForwardRef as ReactComponent };